import { useState, useEffect } from 'react';
import { departmentsAPI } from '../api/services';

export function useDepartments() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      setLoading(true);
      const response = await departmentsAPI.getAll();
      
      // Handle different response formats
      setDepartments(response.departments || response.data || response || []);
      setError(null);
    } catch (err) {
      console.error('Error loading departments:', err);
      setError(err.message);
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  const reload = () => {
    loadDepartments();
  };

  return {
    departments,
    loading,
    error,
    reload,
    loadDepartments
  };
}

export default useDepartments;
